import { render, staticRenderFns } from "./ChipResources.vue?vue&type=template&id=4635db85"
import script from "./ChipResources.vue?vue&type=script&lang=ts"
export * from "./ChipResources.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4635db85')) {
      api.createRecord('4635db85', component.options)
    } else {
      api.reload('4635db85', component.options)
    }
    module.hot.accept("./ChipResources.vue?vue&type=template&id=4635db85", function () {
      api.rerender('4635db85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ChipResources.vue"
export default component.exports